import { render } from "./SunshineGymPrivacyPolicy.vue?vue&type=template&id=1f8ef357"
import script from "./SunshineGymPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./SunshineGymPrivacyPolicy.vue?vue&type=script&lang=js"

import "./SunshineGymPrivacyPolicy.vue?vue&type=style&index=0&id=1f8ef357&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__